import moment from 'moment';

export default {
    state: {
        events_time_period: {},
    },

    mutations: {
        setEventsTimePeriod(state, events) {
            state.events_time_period = events;
        }
    },

    actions: {
        async getEventsTimePeriod({commit}, data) {
            let eventsUrl;

            if (data.group_id) {
                eventsUrl = `/api/v3/events?where_gte=start_date:${data.start}&where_lte=start_date:${data.end}&where=group_id:${data.group_id}&type=group&size=9999`;
            } else {
                eventsUrl = `/api/v3/events?where_gte=start_date:${data.start}&where_lte=start_date:${data.end}&size=9999`;
            }
            
            await axios.get(eventsUrl).then((events) => {
                const { data } = events.data;
                const dates = {};

                for (let i = 0; i < data.length; i += 1) {
                    const date = moment(data[i].start_date).format('YYYY-MM-DD');

                    if (!(date in dates)) {
                        dates[date] = [];
                    }

                    dates[date].push(data[i]);
                }

                commit('setEventsTimePeriod', dates);
            });
        },
    },
}